import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { MatchingQueryParam } from '../api/MatchingApi';
import { ComponentType } from '../../SavedSearch/SavedSearch';
import { MarketingMatchingContactModel } from '../models/MarketingMatchingContactModel';
import { OrderDirection } from '../../Datatable/OrderDirection';
import { QueryItem } from '../../Tonnage/models/TonnageQueryModel';
import ContactNameModel from '../../ContactSelector/models/ContactNameModel';

interface matchingPreviewState {
    openModal: boolean,
    type: ComponentType | null,
    matchingQuery: MatchingQueryParam,
    triggerMatching: number,
    triggerMarketingMatching: number,
    datatable: MarketingMatchingContactModel[],
    contactSearchKeyword: string,
    companyNames: ContactNameModel[],

}

const initialState: matchingPreviewState = {
    openModal: false,
    matchingQuery: {
        lay: "",
        can: "",
        loadAreas: [],
        disAreas: [],
        dwtMin: 0,
        dwtMax: 0,
        excludedCountries: [],
        excludedCompanies: [],
        tonnageDwt: 0,
        marketingMatching: false,
        orderDirection: OrderDirection.Desc,
        orderBy: "updatedDate"
    } as MatchingQueryParam,
    type: null,
    triggerMatching: 0,
    triggerMarketingMatching: 0,
    datatable: [],
    contactSearchKeyword: "",
    companyNames: []
}

export const MatchingPreviewSlice = createSlice({
    name: "MatchingPreview",
    initialState,
    reducers: {
        setOpenModal: (state, action: PayloadAction<boolean>) => {
            state.openModal = action.payload;
        },
        setMatchingQuery: (state, action: PayloadAction<MatchingQueryParam>) => {
            state.matchingQuery = action.payload;
        },
        setComponentType: (state, action: PayloadAction<ComponentType | null>) => {
            state.type = action.payload;
        },
        setTriggerMatching: (state, action: PayloadAction<number>) => {
            state.triggerMatching = action.payload;
        },
        setTriggerMarketingMatching: (state, action: PayloadAction<number>) => {
            state.triggerMarketingMatching = action.payload;
        },
        setMatchingData: (state, action: PayloadAction<MarketingMatchingContactModel[]>) => {
            state.datatable = action.payload;
        },
        setLay: (state, action: PayloadAction<string>) => {
            state.matchingQuery.lay = action.payload;
        },
        setCan: (state, action: PayloadAction<string>) => {
            state.matchingQuery.can = action.payload;
        },
        setLoadAreas: (state, action: PayloadAction<QueryItem[]>) => {
            state.matchingQuery.loadAreas = action.payload;
        },
        setDwtMin: (state, action: PayloadAction<number>) => {
            state.matchingQuery.dwtMin = action.payload;
        },
        setDwtMax: (state, action: PayloadAction<number>) => {
            state.matchingQuery.dwtMax = action.payload;
        },
        setTonnageDwt: (state, action: PayloadAction<number>) => {
            state.matchingQuery.tonnageDwt = action.payload;
        },
        setMatchingOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.matchingQuery.orderDirection = action.payload;
        },
        setMatchingOrderBy: (state, action: PayloadAction<string>) => {
            state.matchingQuery.orderBy = action.payload;
        },
        setExcludedCountries: (state, action: PayloadAction<QueryItem[]>) => {
            state.matchingQuery.excludedCountries = action.payload;
        },
        setExcludedCompanies: (state, action: PayloadAction<QueryItem[]>) => {
            state.matchingQuery.excludedCompanies = action.payload;
        },
        setDisAreas: (state, action: PayloadAction<QueryItem[]>) => {
            state.matchingQuery.disAreas = action.payload;
        },
        setContactSearchKeyword: (state, action: PayloadAction<string>) => {
            state.contactSearchKeyword = action.payload;
        },
        setCompanyNames: (state, action: PayloadAction<ContactNameModel[]>) => {
            state.companyNames = action.payload;
        },
    }
});

export const matchingPreviewSelector = createSelector(
    (state: RootState) => state.matchingPreview,
    (data) => data
);

export const {
    setOpenModal,
    setMatchingQuery,
    setComponentType,
    setTriggerMatching,
    setTriggerMarketingMatching,
    setMatchingData,
    setMatchingOrderDirection,
    setMatchingOrderBy,
    setExcludedCountries,
    setExcludedCompanies,
    setLoadAreas,
    setDisAreas,
    setLay,
    setCan,
    setDwtMin,
    setDwtMax,
    setTonnageDwt,
    setContactSearchKeyword,
    setCompanyNames
} = MatchingPreviewSlice.actions;

export default MatchingPreviewSlice.reducer;